import script from "./CalenderCompo.vue?vue&type=script&setup=true&lang=js"
export * from "./CalenderCompo.vue?vue&type=script&setup=true&lang=js"

import "./style.css?vue&type=style&index=0&lang=css&external"

const __exports__ = script;

export default __exports__